import axios from 'axios';

const pathNotifications =
	'https://8siu8hczc2.execute-api.us-east-1.amazonaws.com/Prod/notifications';

export const getNotificationsUser = async (email, nit, page, limit) => {
	try {
		const response = await axios.get(pathNotifications, { params: { email, nit, page, limit } });
		return response;
	} catch (error) {
		console.error(error);
		return error.response
	}
};

export const markNotificationRead = async (notificationId, email) => {
  try {
    const response = await axios.post(pathNotifications, null, {
      params: { notificationId, email },
    });
    return response; 
  } catch (error) {
    console.error(error);
    return error.response; 
  }
}

